module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "mb-5": ""
    }
  }, [_c('v-layout', {
    staticClass: "border-content mt-5 pa-4 mb-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "mb-5": ""
    }
  }, [_c('div', {
    staticClass: "company-header"
  }, [_vm._v("\r\n        Usuários\r\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "tb-users",
    attrs: {
      "cellspacing": "0",
      "cellspadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Login")]), _vm._v(" "), _c('th', [_vm._v("Telfone")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Departamento")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.telefone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.departamento))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "",
        "flat": "",
        "color": "grey lighten-1"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemEscolha(item.id)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("create")])], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "v-subheader theme--light"
  }, [_vm._v("itens por página")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "value": _vm.itemsPerPage,
      "bottom": "",
      "required": "",
      "items": _vm.comboList
    },
    on: {
      "change": _vm.refreshList
    },
    model: {
      value: (_vm.ipp),
      callback: function($$v) {
        _vm.ipp = $$v
      },
      expression: "ipp"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "pt-3 pr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.pagingText))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage > 1),
      expression: "currentPage > 1"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage < _vm.totalPages),
      expression: "currentPage < totalPages"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.itemEscolha(0)
      }
    }
  }, [_c('span', {
    staticClass: "pr-1"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_circle_outline")])], 1), _vm._v("\r\n        Novo Usuário\r\n      ")]), _vm._v(" "), _c('UsuarioDetalhes')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9c978fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/conta/usuarios.vue
// module id = 779
// module chunks = 10